export function isLoadingAction(isLoading:boolean){
    return {
        type: "@@loading/isLoadingAction" as const,
        isLoading
    }
}

export type LoadingAction =
ReturnType<typeof isLoadingAction>